export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";
export const SET_PROFILE_IMAGE = "setProfileImage";



// WEBPACK FOOTER //
// ./src/store/mutations.type.js